var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'side-opened': _vm.sideOpened },attrs:{"id":"songs-switcher"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('IconChevronDown',{staticClass:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }